import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InwardStatus } from 'src/app/Enums/inwardEnum';
import { StatusService } from 'src/app/shared/components/status.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';

@Component({
  selector: 'app-inward-progress-bar',
  templateUrl: './inward-progress-bar.component.html',
  styleUrls: ['./inward-progress-bar.component.less']
})
export class InwardProgressBarComponent implements OnInit {
  public statusId : any;
  id: any;
  viewData : any;
  showLoader: boolean = true;
  InwardStatus : InwardStatus;
  nonreturnable: number = 0;
  created: number = 0;
  checked: number = 0;
  declined: number = 0;
  collected: number = 0;
  challan: number = 0;
  received: number = 0;

  private unsubscribe$ =new Subject<void>();
  service_URL: any;
  
  constructor(
    private service:StatusService,
    private route: ActivatedRoute,
    private _dataContextService: DataContextService) {
      this.service_URL = ConstantsService;
      this.created = InwardStatus.Created;
      this.checked = InwardStatus.Checked;
      this.declined = InwardStatus.Declined;
      this.collected = InwardStatus.Collected;
      this.challan = InwardStatus.ChallanUploaded;
      this.received = InwardStatus.Received;
      this.nonreturnable = InwardStatus.NonReturnable;
    }

  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];
    this.getDataById(this.id);
  }

  showTrOpen(){
    if(this.statusId == this.received){
      return false;
    }
    return true;
  }

  getDataById(id: number) {
    let url =this.service_URL.InwardDetails.ViewRequest + '/' + id;
       
    this._dataContextService.get<any>(url)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res=>{
      // console.log(res);
      this.viewData = res;
      this.statusId = this.viewData.statusId;
      this.showLoader = false;
    });
    }
}

